const timeConvert = (seconds) => new Date(seconds * 1000).toISOString().substr(11, 8)

export const time = {
  'parseDuration': duration => timeConvert(Number(duration))
}